import React from 'react';
import RequestWizardActions from './RequestWizardActions';
import RequestSummaryActions from './RequestSummaryActions';
import Selectors from '../hooks/selectors';

const RequestActions = ({ category, code }) => {
  const { isNew } = Selectors.useRequestActions({ category, code });
  return (
    <>
      {isNew && (<RequestWizardActions category={category} code={code} />)}
      {!isNew && (<RequestSummaryActions category={category} code={code} />)}
    </>
  );
};

export default RequestActions;
